const appConfig = {
  servicePrefix: {
    local: {
      auth: "http://localhost:40001",
      district: "http://localhost:40002",
      app: "http://localhost:40003",
    },
    production: {
      auth: "https://api-epon-auth.bandung.go.id",
      district: "https://api-epon-district.bandung.go.id",
      app: "https://api-epon-app.bandung.go.id",
    },
  },
  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: false,
  stage: "production",
};

export default appConfig;
